import KioskLogo from '@/components/ui/KioskLogo'
import LanguageToggle from '@/components/ui/LanguageToggle'
import { useKioskStore } from '@/stores/kiosk-store'

export default function KioskHeader() {
  const menuType = useKioskStore((s) => s.menuType)
  const locale = useKioskStore((s) => s.locale)
  const remoteConfig = useKioskStore((s) => s.remoteConfig)
  const currentCategoryLabel = useKioskStore((s) => s.currentCategoryLabel)
  const backAction = useKioskStore((s) => s.backAction)
  const sv = locale === 'sv'
  const isLandscape = remoteConfig?.layoutMode === 'landscape'
  return (
    <>
      {/* ─── Consolidated header (same design in portrait and landscape) ─── */}
      {/* Portrait keeps the same structure as landscape but with slightly smaller title font */}
      <div className={`shrink-0 bg-kiosk-surface border-b border-kiosk-surface-2 relative ${isLandscape ? 'px-8 py-6' : 'px-6 py-5'}`}>
        {/* LEFT: Logo + Back arrow */}
        <div className={`absolute top-1/2 -translate-y-1/2 flex items-center gap-3 ${isLandscape ? 'left-8' : 'left-6'}`}>
          <KioskLogo className="w-16 h-16 shrink-0 flex items-center justify-center rounded-full overflow-hidden" />
          {backAction && (
            <button
              type="button"
              onClick={() => {
                if (backAction) backAction()
              }}
              className="kiosk-btn h-14 pl-4 pr-5 rounded-full flex items-center gap-2.5 bg-kiosk-accent text-kiosk-bg shadow-md"
            >
              <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
              </svg>
              <span className="font-bold text-lg">{sv ? 'Tillbaka' : 'Back'}</span>
            </button>
          )}
        </div>

        {/* CENTER: Page title — absolutely centered on screen width */}
        {currentCategoryLabel && (
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
            <span className={`text-kiosk-text font-bold uppercase tracking-widest whitespace-nowrap ${isLandscape ? 'text-3xl' : 'text-2xl'}`}>{currentCategoryLabel}</span>
          </div>
        )}

        {/* RIGHT: Menu type badge + language flags only */}
        <div className={`absolute top-1/2 -translate-y-1/2 flex items-center gap-4 ${isLandscape ? 'right-8' : 'right-6'}`}>
          {menuType && (
            <span className={`text-kiosk-accent font-semibold rounded-full bg-kiosk-accent/10 border border-kiosk-accent/30 whitespace-nowrap px-4 py-2 ${isLandscape ? 'text-base' : 'text-sm'}`}>
              {menuType === 'EatIn' ? (sv ? '🍽 Äta här' : '🍽 Eat in') : sv ? '🛍 Ta med' : '🛍 Takeaway'}
            </span>
          )}
          <LanguageToggle position="top" flagsOnly />
        </div>

        {/* Invisible spacer to give the bar its height */}
        <div className="h-20" />
      </div>
    </>
  )
}
